<ng-container *ngIf="viewModel$ | async as vm">
  <pw-view-title>{{vm?.incident?.NAME}}</pw-view-title>

  <pw-view-actions>
    <button mat-icon-button (click)="openSearchDialog()">
      <mat-icon>find_in_page</mat-icon>
    </button>
    <button mat-button matTooltip="{{'incidents.incidentDetails.confirm' | translate}}" (click)="acceptIncident()">
      <mat-icon>
        thumb_up
      </mat-icon>
    </button>
    <button mat-button matTooltip="{{'incidents.incidentDetails.createPlannedDelivery' | translate}}"
            (click)="openCreatePlannedDeliveryBottomsheet(vm.incident)" *ngIf="vm.canCreateDelivery">
      <mat-icon matBadge="+">
        local_shipping
      </mat-icon>
    </button>
  </pw-view-actions>

  <div class="ps-grid-2-col">

    <mat-card>
      <mat-card-header>
        <div matCardTitle style="font-weight: bold">
          {{vm.incident?.SNR}} {{vm.incident?.ORDERNR}} {{vm.incident?.DATUMERSTELLUNG | date: 'short'}}
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="ps-grid-3-col">
          <div>{{'incidents.incidentDetails.category' | translate}}: {{vm.incident?.CATEGORYNAME}}</div>
          <div>{{'incidents.incidentDetails.error' | translate}}: {{vm.incident?.ERRORNAME}}</div>
          <div>{{'incidents.incidentDetails.priority' | translate}}: {{vm.incident?.PRIONAME}}</div>
          <div>{{'incidents.incidentDetails.status' | translate}}: {{vm.incident?.STATUSNAME}}</div>
          <div>{{'incidents.incidentDetails.affectedParts' | translate}}: {{vm.incident?.PARTS_AFFECTED}}</div>
        </div>

        <mat-divider style="padding: 8px"></mat-divider>

        <div class="incident-description">
          {{vm.incident?.PROBLEM_BESCHREIBUNG}}
        </div>

      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <div matCardTitle>Dokumente</div>
      </mat-card-header>

      <mat-card-content>
        <mat-tab-group>
          <mat-tab label="{{'incidents.incidentDetails.documents' | translate}}">
            <mat-list *ngIf="vm.documents?.length > 0; else noDocuments">
              <mat-list-item *ngFor="let doc of vm.documents">
              <span matListItemLine>{{doc.NAME}}
                <mat-icon (click)="downloadDocument(doc)">file_download</mat-icon></span>
              </mat-list-item>
            </mat-list>
            <ng-template #noDocuments>
              <div>{{'incidents.incidentDetails.noDocuments' | translate}}</div>
            </ng-template>
          </mat-tab>

          <mat-tab label="{{'incidents.incidentDetails.preview' | translate}}">
            <div *ngIf="vm.previewImages?.length > 0; else noImages">
              <pw-gallery [images]="vm.previewImages"></pw-gallery>
            </div>
          </mat-tab>
          <ng-template #noImages>
            <div>{{'incidents.incidentDetails.noPreview' | translate}}</div>
          </ng-template>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>

    <mat-card style="grid-column: span 2">
      <mat-card-header>
        <div matCardTitle>{{'incidents.incidentDetails.returns' | translate}}</div>
      </mat-card-header>
      <mat-card-content>
        <ps-planned-delivery [deliveries]="vm.deliveries" [icons]="vm.icons" [pos]="vm.pos"
                             [isLoading]="false"></ps-planned-delivery>
      </mat-card-content>
    </mat-card>

    <mat-card style="grid-column: span 2">
      <mat-card-header>
        <mat-card-title>{{'incidents.incidentDetails.comments' | translate}}</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="ps-grid-2-col comments-container">
          <div *ngFor="let comment of vm.comments" class="comment"
               [class]="getAuthorClass(comment)">
            <div class="comment-author">{{comment.USERNAME}} <span
              style="font-weight: normal"> - {{comment.ACTION_DATUM | date: 'short'}}</span>
            </div>
            <mat-divider style="margin: 8px"></mat-divider>
            <div class="comment-text">{{ comment.COMMENT }}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

  </div>

  <button mat-mini-fab style="position: fixed; bottom: 20px; right: 20px"
          (click)="openCreateCommentSheet(vm.incident)">
    <mat-icon>
      chat
    </mat-icon>
  </button>

</ng-container>

